import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useApi } from '../../hooks/useApi';
import LoadingSpinner from '../../components/Common/LoadingSpinner';
import { ArrowLeftIcon, PencilIcon } from '@heroicons/react/24/outline';

const FileTypeDetails = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const { get, loading } = useApi();
  const [fileType, setFileType] = useState(null);

  useEffect(() => {
    fetchFileType();
  }, [id]);

  const fetchFileType = async () => {
    const { data } = await get(`/api/file-types/${id}`);
    if (data) setFileType(data);
  };

  if (loading) return <LoadingSpinner />;
  if (!fileType) return <div className="p-6">File Type not found</div>;

  return (
    <div className="p-6 max-w-2xl mx-auto">
      <div className="flex items-center justify-between mb-6">
        <div className="flex items-center">
          <button
            onClick={() => navigate('/file-types')}
            className="mr-4 text-gray-600 hover:text-gray-900"
          >
            <ArrowLeftIcon className="h-6 w-6" />
          </button>
          <h1 className="text-2xl font-bold text-gray-800">File Type Details</h1>
        </div>
        <button
          onClick={() => navigate(`/file-types/edit/${id}`)}
          className="bg-indigo-600 text-white px-4 py-2 rounded-lg hover:bg-indigo-700 flex items-center space-x-2"
        >
          <PencilIcon className="h-5 w-5" />
          <span>Edit</span>
        </button>
      </div>

      <div className="bg-white rounded-xl shadow-lg p-6">
        <div className="space-y-6">
          <div>
            <label className="text-sm text-gray-500">ID</label>
            <p className="text-lg font-medium">{fileType.id}</p>
          </div>
          <div>
            <label className="text-sm text-gray-500">File Name</label>
            <p className="text-lg font-medium">{fileType.fileName}</p>
          </div>
          <div>
            <label className="text-sm text-gray-500">File Description</label>
            <p className="text-lg font-medium whitespace-pre-wrap">{fileType.fileDescription}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FileTypeDetails;